import { useState } from 'react';
import { supabase } from '@/lib/supabase';

const ESTADOS_MX = [
  'Aguascalientes','Baja California','Baja California Sur','Campeche','Chiapas',
  'Chihuahua','Ciudad de México','Coahuila','Colima','Durango','Guanajuato',
  'Guerrero','Hidalgo','Jalisco','Estado de México','Michoacán','Morelos',
  'Nayarit','Nuevo León','Oaxaca','Puebla','Querétaro','Quintana Roo',
  'San Luis Potosí','Sinaloa','Sonora','Tabasco','Tamaulipas','Tlaxcala',
  'Veracruz','Yucatán','Zacatecas'
];

interface Props {
  memberId: string;
  onClose: () => void;
  onGuardado: (ciudad: string, estado: string) => void;
}

export default function InfoFaltanteModal({ memberId, onClose, onGuardado }: Props) {
  const [ciudad, setCiudad] = useState('');
  const [estado, setEstado] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleGuardar = async () => {
    if (!ciudad.trim()) { setError('Ingresa tu ciudad'); return; }
    if (!estado) { setError('Selecciona tu estado'); return; }
    setSaving(true); setError('');
    const { error: err } = await supabase
      .from('members')
      .update({ ciudad: ciudad.trim(), estado_residencia: estado })
      .eq('id', memberId);
    if (err) {
      setError('Error al guardar. Intenta de nuevo.');
      setSaving(false);
    } else {
      onGuardado(ciudad.trim(), estado);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="bg-white w-full max-w-md rounded-3xl px-6 pt-6 pb-8">

        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: '#FEF3C7' }}>
            <i className="ri-map-pin-line text-amber-500 text-lg" />
          </div>
          <div>
            <h3 className="font-bold text-[#0d0520] text-base">Confirma tu ubicación</h3>
            <p className="text-gray-400 text-xs">Necesitamos tu ciudad y estado para tu perfil</p>
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide block mb-1.5">Estado *</label>
            <select
              value={estado}
              onChange={e => setEstado(e.target.value)}
              className="w-full border rounded-xl px-4 py-3 text-sm outline-none focus:border-[#534AB7]"
              style={{ borderColor: '#E5E7EB' }}
            >
              <option value="">Selecciona tu estado</option>
              {ESTADOS_MX.map(e => <option key={e} value={e}>{e}</option>)}
            </select>
          </div>

          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide block mb-1.5">Ciudad *</label>
            <input
              type="text"
              placeholder="Ej. Culiacán, Los Mochis, Mazatlán..."
              value={ciudad}
              onChange={e => { setCiudad(e.target.value); setError(''); }}
              className="w-full border rounded-xl px-4 py-3 text-sm outline-none focus:border-[#534AB7]"
              style={{ borderColor: '#E5E7EB' }}
            />
          </div>

          {error && <p className="text-red-500 text-xs">{error}</p>}

          <div className="flex gap-3 mt-2">
            <button
              onClick={onClose}
              className="flex-1 py-3.5 rounded-full border text-sm font-semibold text-gray-500"
              style={{ borderColor: '#E5E7EB' }}
            >Después</button>
            <button
              onClick={handleGuardar}
              disabled={saving}
              className="flex-1 py-3.5 rounded-full text-white text-sm font-bold"
              style={{ backgroundColor: '#534AB7' }}
            >{saving ? 'Guardando...' : 'Guardar'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
